import React, { Component } from 'react'
import { View, TouchableOpacity, Modal, Image } from 'react-native'
import Text from '../Text/MyText'

import {
  MainColor,
  SecondaryColor,
  FontMainColor,
  FontSecondaryColor,
  FontThirdColor,
} from '../../UI/Color'
import {
  WidthDimen,
  HeightDimen,
  fontDimen,
  GetWidth,
  GetHeight,
} from '../../UI/Dimensions'

import { ImageButton } from '../../Component/Button/ImageButton'
import { TextButton } from '../../Component/Button/TextButton'
import { strings } from '../../Language/Language'

const InGameModal = (props) => {
  const { isShow, onBackPressed } = props

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={isShow}
      statusBarTranslucent
    >
      <View
        style={{
          flex: 1,
          backgroundColor: 'rgba(0,0,0,0.5)',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <View
          style={{
            backgroundColor: 'white',
            padding: HeightDimen(25),
            alignItems: 'center',
            borderRadius: HeightDimen(10),
          }}
        >
          <Text
            style={{
              fontSize: fontDimen(15),
              marginBottom: HeightDimen(20),
            }}
          >
            {strings.t('close_game_first')}
          </Text>
          <TextButton
            label={strings.t('confirm')}
            size={3}
            onPress={onBackPressed}
          />
        </View>
      </View>
    </Modal>
  )
}

export { InGameModal }
